export default __webpack_public_path__ + "static/media/upstox.a7e12191.svg";